export default __webpack_public_path__ + "static/media/noData.8f2aed43.svg";